import ма from '../data/media/syllablesSet1/ма.mp3'
import мо from '../data/media/syllablesSet1/мо.mp3'
import ме from '../data/media/syllablesSet1/ме.mp3'
import му from '../data/media/syllablesSet1/му.mp3'
import ми from '../data/media/syllablesSet1/ми.mp3'
import ка from '../data/media/syllablesSet1/ка.mp3'
import ко from '../data/media/syllablesSet1/ко.mp3'
import ке from '../data/media/syllablesSet1/ке.mp3'
import ку from '../data/media/syllablesSet1/ку.mp3'
import ки from '../data/media/syllablesSet1/ки.mp3'
import та from '../data/media/syllablesSet1/та.mp3'
import то from '../data/media/syllablesSet1/то.mp3'
import те from '../data/media/syllablesSet1/те.mp3'
import ту from '../data/media/syllablesSet1/ту.mp3'
import ти from '../data/media/syllablesSet1/ти.mp3'
import са from '../data/media/syllablesSet1/са.mp3'
import со from '../data/media/syllablesSet1/со.mp3'
import се from '../data/media/syllablesSet1/се.mp3'
import су from '../data/media/syllablesSet1/су.mp3'
import си from '../data/media/syllablesSet1/си.mp3'
import на from '../data/media/syllablesSet1/на.mp3'
import ха from '../data/media/syllablesSet1/ха.mp3'
import но from '../data/media/syllablesSet1/но.mp3'
import хо from '../data/media/syllablesSet1/хо.mp3'
import не from '../data/media/syllablesSet1/не.mp3'
import хе from '../data/media/syllablesSet1/хе.mp3'
import ну from '../data/media/syllablesSet1/ну.mp3'
import ху from '../data/media/syllablesSet1/ху.mp3'
import ба from '../data/media/syllablesSet1/ба.mp3'
import ва from '../data/media/syllablesSet1/ва.mp3'
import бо from '../data/media/syllablesSet1/бо.mp3'
import ве from '../data/media/syllablesSet1/ве.mp3'
import бе from '../data/media/syllablesSet1/бе.mp3'
import бу from '../data/media/syllablesSet1/бу.mp3'
import ву from '../data/media/syllablesSet1/ву.mp3'
import ра from '../data/media/syllablesSet1/ра.mp3'
import па from '../data/media/syllablesSet1/па.mp3'
import ру from '../data/media/syllablesSet1/ру.mp3'
import пу from '../data/media/syllablesSet1/пу.mp3'
import ро from '../data/media/syllablesSet1/ро.mp3'
import по from '../data/media/syllablesSet1/по.mp3'
import ре from '../data/media/syllablesSet1/ре.mp3'
import пе from '../data/media/syllablesSet1/пе.mp3'
import да from '../data/media/syllablesSet1/да.mp3'
import до from '../data/media/syllablesSet1/до.mp3'
import ду from '../data/media/syllablesSet1/ду.mp3'
import ди from '../data/media/syllablesSet1/ди.mp3'
import га from '../data/media/syllablesSet1/га.mp3'
import го from '../data/media/syllablesSet1/го.mp3'
import гу from '../data/media/syllablesSet1/гу.mp3'
import ги from '../data/media/syllablesSet1/ги.mp3'
import за from '../data/media/syllablesSet1/за.mp3'
import зо from '../data/media/syllablesSet1/зо.mp3'
import зу from '../data/media/syllablesSet1/зу.mp3'
import зи from '../data/media/syllablesSet1/зи.mp3'
import ла from '../data/media/syllablesSet1/ла.mp3'
import ло from '../data/media/syllablesSet1/ло.mp3'


export const syllableSet1 = [
    [
        {text:"ма", audio:ма}, 
        {text:"мо", audio:мо}, 
        {text:"ме", audio:ме}, 
        {text:"му", audio:му}, 
        {text:"ми", audio:ми}, 
        {text:"ка", audio:ка}
    ], 
    
    [
        {text:"ко",audio:ко}, 
        {text:"ке", audio:ке}, 
        {text:"ку", audio:ку}, 
        {text:"ки", audio:ки}, 
        {text:"та", audio:та}, 
        {text:"то", audio:то}
    ],
    [ 
        {text:"те", audio:те}, 
        {text:"ту", audio:ту}, 
        {text:"ти", audio:ти},
        {text:"са", audio:са}, 
        {text:"со", audio:со}, 
        {text:"се", audio:се}
    ],
    [
        {text:"су", audio:су}, 
        {text:"си", audio:си}, 
        {text:"ка", audio:ка}, 
        {text:"ко", audio:ко},
        {text:"на", audio:на},
        {text:"ха", audio:ха}
    ],
    [
        {text:"но", audio:но}, 
        {text:"хо", audio:хо}, 
        {text:"не", audio:не}, 
        {text:"хе", audio:хе}, 
        {text:"ну", audio:ну}, 
        {text:"ху", audio:ху}
    ],

    [
        {text:"ба", audio:ба}, 
        {text:"ва", audio:ва}, 
        {text:"бо", audio:бо}, 
        {text:"ве", audio:ве}, 
        {text:"бе", audio:бе}, 
        {text:"ху", audio:ху}
    ],

    [
        {text:"бу", audio:бу}, 
        {text:"ву", audio:ву}, 
        {text:"ра", audio:ра}, 
        {text:"па", audio:па}, 
        {text:"ру", audio:ру}, 
        {text:"пу", audio:пу}
    ],

    [
        {text:"ро", audio:ро}, 
        {text:"по", audio:по}, 
        {text:"ре", audio:ре}, 
        {text:"пе", audio:пе}, 
        {text:"да", audio:да}, 
        {text:"до", audio:до}
    ],

    [
        {text:"ду", audio:ду}, 
        {text:"ди", audio:ди}, 
        {text:"га", audio:га}, 
        {text:"го", audio:го}, 
        {text:"гу", audio:гу}, 
        {text:"ги", audio:ги}
    ],

    [
        {text:"за", audio:за}, 
        {text:"зо", audio:зо}, 
        {text:"зу", audio:зу}, 
        {text:"зи", audio:зи}, 
        {text:"ла", audio:ла}, 
        {text:"ло", audio:ло}
    ]
]

export const syllableSet2 = [
    [
        {text:"ак"}, 
        {text:"тё"}, 
        {text:"рё"}, 
        {text:"кё"}, 
        {text:"ка"}, 
        {text:"кё"}
    ],
    [
        {text:"ар"}, 
        {text:"ро"}, 
        {text:"бат"}, 
        {text:"та"}, 
        {text:"бо"}, 
        {text:"кё"}
    ],
    [
        {text:"ст"}, 
        {text:"ар"}, 
        {text:"ти"}, 
        {text:"арт"}, 
        {text:"тар"}, 
        {text:"ист"}
    ],
    [
        {text:"шо"}, 
        {text:"фё"}, 
        {text:"ро"}, 
        {text:"ди"}, 
        {text:"ре"}, 
        {text:"тор"}
    ],
    [
        {text:"ме"}, 
        {text:"не"}, 
        {text:"дж"}, 
        {text:"же"}, 
        {text:"жер"}, 
        {text:"реж"}
    ]
]

export const syllableSet3 = [
    [
        {text:"ме"}, 
        {text:"вут"}, 
        {text:"дже"}, 
        {text:"чан"}, 
        {text:"тёр"}, 
        {text:"тая"}
    ],
    [
        {text:"хар"}, 
        {text:"ве"}, 
        {text:"бри"}, 
        {text:"та"}, 
        {text:"ния"}, 
        {text:"аф"}
    ],
    [
        {text:"лон"}, 
        {text:"же"}, 
        {text:"нер"}, 
        {text:"юж"}, 
        {text:"ной"}, 
        {text:"ки"}
    ],
    [
        {text:"кио"}, 
        {text:"мо"}, 
        {text:"ра"}, 
        {text:"та"}, 
        {text:"прн"}, 
        {text:"зи"}
    ],
    [
        {text:"дент"}, 
        {text:"гел"}, 
        {text:"мер"}, 
        {text:"кель"}, 
        {text:"кан"}, 
        {text:"цлер"}
    ],
    [
        {text:"люк"}, 
        {text:"бесс"}, 
        {text:"сон"}, 
        {text:"фран"}, 
        {text:"де"}, 
        {text:"реж"}
    ],
    [
        {text:"сан"}, 
        {text:"др"}, 
        {text:"веч"}, 
        {text:"хок"}, 
        {text:"ль"}, 
        {text:"ист"}
    ],
    [
        {text:"ха"}, 
        {text:"сан"}, 
        {text:"шаш"}, 
        {text:"тур"}, 
        {text:"дель"}, 
        {text:"джо"}
    ],
    [
        {text:"руж"}, 
        {text:"ар"}, 
        {text:"ма"}, 
        {text:"ни"}, 
        {text:"таль"}, 
        {text:"ко"}
    ]
]

